import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';

import {
  PASSWORD_RULE_KEYS,
  evaluatePasswordRules,
} from '../schemas/resetPassword.schema';
import { cn } from '@/lib/utils';

/** Live checklist of the five password rules, reflecting the current input. */
export function PasswordRules({ password }: { password: string }) {
  const { t } = useTranslation();
  const rules = evaluatePasswordRules(password);

  return (
    <ul className="grid grid-cols-1 gap-1.5 pt-0.5 sm:grid-cols-2">
      {PASSWORD_RULE_KEYS.map((key) => {
        const met = rules[key];
        return (
          <li
            key={key}
            className={cn(
              'flex items-center gap-2 text-xs',
              met ? 'text-success' : 'text-muted-foreground',
            )}
          >
            <span
              className={cn(
                'grid h-4 w-4 shrink-0 place-items-center rounded-full',
                met
                  ? 'bg-success/15 text-success'
                  : 'bg-muted text-muted-foreground',
              )}
            >
              {met ? (
                <Check className="h-3 w-3" strokeWidth={3} />
              ) : (
                <X className="h-3 w-3" />
              )}
            </span>
            {t(`auth.${key}`)}
          </li>
        );
      })}
    </ul>
  );
}
